import axios from 'axios'
import _ from 'lodash'

const options = process.env.VUE_APP_BASIC_AUTH_USER ?
  {
    auth: {
      username: process.env.VUE_APP_BASIC_AUTH_USER,
      password: process.env.VUE_APP_BASIC_AUTH_PASS
    }
  }
  :
  {}

const localeChecker = (locale) => {

  if(!locale) locale = 'ja'
  else if(locale === 'zh') locale = 'zh-hans'

  return locale
}

export default {

  fetchSnippets (ep, lang, cb) {
    // console.log('fetchSnippets', process.env.VUE_APP_ROOT_API + '/api/v2/' + ep + '/', options)
    axios.get(process.env.VUE_APP_ROOT_API + '/api/v2/' + ep + '/', options)
    .then(response => {
      cb(response.data)
    })
    .catch(e => {
      cb(e)
    })
  },

  fetchPageByPath (path, slug, lang, cb) {
    const locale = localeChecker(lang)
    if (_.isNull(path)) return false
    // console.log('fetchPageByPath', process.env.VUE_APP_ROOT_API + '/api/v2/pages/find/?html_path=' + path + '&locale=' + locale, options)
    axios.get(process.env.VUE_APP_ROOT_API + '/api/v2/pages/find/?html_path=' + path + '&locale=' + locale, options)
    .then(response => {
      cb({ [slug]: response.data })
    })
    .catch(e => {
      cb(e)
    })
  },

  fetchPageByType (type, slug, lang, cb) {
    const locale = localeChecker(lang)
    if (_.isNull(type) || _.isNull(slug)) return false
    // console.log('fetchPageByType', process.env.VUE_APP_ROOT_API + '/api/v2/pages/?type=' + type + '&slug=' + slug + '&fields=*&locale=' + locale, options)
    axios.get(process.env.VUE_APP_ROOT_API + '/api/v2/pages/?type=' + type + '&slug=' + slug + '&fields=*&locale=' + locale, options)
    .then(response => {
      cb({ [slug]: response.data })
    })
    .catch(e => {
      cb(e)
    })
  },

  fetchSpotList (lang, cb) {
    const locale = localeChecker(lang)
    // console.log('fetchSpotList', process.env.VUE_APP_ROOT_API + '/api/v2/pages/?type=spot.SpotPage&fields=image,thumb,square,keywords,locations,views,published_date&limit=60&locale=' + locale, options)
    axios.get(process.env.VUE_APP_ROOT_API + '/api/v2/pages/?type=spot.SpotPage&fields=image,thumb,square,keywords,locations,views,published_date&limit=60&locale=' + locale, options)
    .then(response => {
      cb(response.data)
    })
    .catch(e => {
      cb(e)
    })
  },

  fetchTourList (lang, cb) {
    const locale = localeChecker(lang)
    // console.log('fetchTourList', process.env.VUE_APP_ROOT_API + '/api/v2/pages/?type=tour.TourPage&fields=image,thumb,duration,preview,preview_text,views,published_date&limit=60&locale=' + locale, options)
    axios.get(process.env.VUE_APP_ROOT_API + '/api/v2/pages/?type=tour.TourPage&fields=image,thumb,duration,preview,preview_text,views,published_date&limit=60&locale=' + locale, options)
    .then(response => {
      cb(response.data)
    })
    .catch(e => {
      cb(e)
    })
  },

}
